import React, { HTMLAttributes } from 'react';

import {
  View,
} from '@uncinc/react-drupal-core';
import {
  ImmutableEntity,
} from '@uncinc/react-drupal-core/types';
import { Button } from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';
import { ParagraphText } from '../../../types/uncinc_profile/paragraphs';

interface ParagraphArticleHighlightsProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<ParagraphText>;
}

const ParagraphArticleHighlights: React.FC<ParagraphArticleHighlightsProps> = ({ entity }) => {
  const paragraphArticleHighlights = entity.toJS();
  const uuid = paragraphArticleHighlights.uuid[0].value;
  const title = paragraphArticleHighlights.field_title[0]?.value;
  const link = paragraphArticleHighlights.field_link?.[0];
  const linkTitle = link?.title;
  const linkUri = link?.alias || link?.uri;

  return (
    <div id={uuid} className="ParagraphArticleHighlights">
      {title && <h2>{title}</h2>}
      <View
        classes="row"
        id="article"
        display="highlights"
        storageType="url"
      />
      {linkUri && (
      <Button
        href={linkUri}
        className="ParagraphCTA__button icon-after icon-arrow icon-variant-1"
      >
        {linkTitle}
      </Button>
      )}
    </div>
  );
};

export default ParagraphArticleHighlights;
